import { render } from "./adminnav.vue?vue&type=template&id=c2cdd6b0"
import script from "./adminnav.vue?vue&type=script&lang=js"
export * from "./adminnav.vue?vue&type=script&lang=js"

import "./adminnav.vue?vue&type=style&index=0&id=c2cdd6b0&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__